// import React from 'react';
// import Picker from 'rc-calendar/lib/Picker';
// import RangeCalendar from 'rc-calendar/lib/RangeCalendar';
// import zhCN from 'rc-calendar/lib/locale/zh_CN';
// import enUS from 'rc-calendar/lib/locale/en_US';
// import TimePickerPanel from 'rc-time-picker/lib/Panel';
// import 'rc-calendar/assets/index.css';
// import 'rc-time-picker/assets/index.css';

// import moment from 'moment';
// import 'moment/locale/zh-cn';
// import 'moment/locale/en-gb';

// const cn = window.location.search.indexOf('cn') !== -1;

// if (cn) {
//   moment.locale('zh-cn');
// } else {
//   moment.locale('en-gb');
// }

// const now = moment();
// if (cn) {
//   now.utcOffset(8);
// } else {
//   now.utcOffset(0);
// }

// const formatStr = 'YYYY-MM-DD HH:mm:ss';

// function newArray(start, end) {
//   const result = [];
//   for (let i = start; i < end; i++) {
//     result.push(i);
//   }
//   return result;
// }

// function disabledDate(current) {
//     if (!current) {
//       return false;
//     }
//     const date = moment();
//     date.hour(0);
//     date.minute(0);
//     date.second(0);
//     return current.isBefore(date);
//   }
  

// function disabledTime(time, type) {
//   if (type === 'start') {
//     return {
//       disabledHours() {
//         const hours = newArray(0, 24);
//         hours.splice(20, 4);
//         return hours;
//       },
//       disabledMinutes(h) {
//         if (h === 20) {
//           return newArray(0, 31);
//         } else if (h === 23) {
//           return newArray(30, 60);
//         }
//         return [];
//       },
//       disabledSeconds() {
//         return [55, 56];
//       },
//     };
//   }
//   return {
//     disabledHours() {
//       const hours = newArray(0, 24);
//       hours.splice(2, 6);
//       return hours;
//     },
//     disabledMinutes(h) {
//       if (h === 20) {
//         return newArray(0, 31);
//       } else if (h === 23) {
//         return newArray(30, 60);
//       }
//       return [];
//     },
//     disabledSeconds() {
//       return [55, 56];
//     },
//   };
// }

// function format(value) {
//   return value ? value.format(formatStr) : '';
// }

// function isValidRange(value) {
//   return value && value[0] && value[1];
// }

// const timePickerElement = (
//   <TimePickerPanel
//     defaultValue={[moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]}
//   />
// );

// const DateRangePicker = ({ locale = cn ? zhCN : enUS, onChange, disabled }) => {
//   const [value, setValue] = React.useState([]);
//     const resetValue = () => {
//     setValue([]);
//   };
//   const [hoverValue, setHoverValue] = React.useState([]);

//   const handleChange = (value) => {
//     setValue(value);
//     onChange && onChange(value);
//   };

//   const calendar = (
//     <RangeCalendar
//       hoverValue={hoverValue}
//       onHoverChange={setHoverValue}
//       dateInputPlaceholder={['start', 'end']}
//       defaultValue={[now, now.clone().add(1, 'months')]}
//       locale={locale}
//       disabledDate={disabledDate}
//       disabledTime={disabledTime}
//       timePicker={timePickerElement}
//       showOk={false} // Hides the "OK" button
//     />
//   );

//   return (
//     <Picker
//       value={value}
//       onChange={handleChange}
//       animation="slide-up"
//       calendar={calendar}
//     >
//       {({ value }) => (
//         <span>
//           {/* Always show this input div regardless of the calendar's open/close state */}
//           <div className="w-[390px] h-[40px] bg-[white] text-[#b2b2b2] items-center border border-[#dcdfe6] rounded flex group z-0">
//             <svg
//             className="w-4 h-4 ml-3"
//             focusable="false"
//             aria-hidden="true"
//             viewBox="0 0 24 24"
//             data-testid="AccessTimeIcon"
//             title="AccessTime"
//             fill="#b2b2b2"
//             >
//                 <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
//                 <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"></path>
//             </svg>

//             <input
//               placeholder="Start Range"
//               disabled={disabled}
//               readOnly
//               className="w-[150px] h-full outline-none text-center text-[black]"
//               value={isValidRange(value) && format(value[0])}
//             />
//             <span>~</span>
//             <input
//               placeholder="End Range"
//               disabled={disabled}
//               readOnly
//               className="w-[150px] h-full outline-none text-center text-[black]"
//               value={isValidRange(value) && format(value[1])}
//             />
//             {value.length > 1 && (
//               <div
//                 onClick={resetValue}
//                 className="h-[40px] w-[40px] outline-none bg-[transparent] flex flex-col justify-center z-100 cursor-pointer"
//               >
//                 <svg
//                   className="w-4 h-4 ml-5 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
//                   focusable="false"
//                   viewBox="0 0 24 24"
//                   data-testid="HighlightOffIcon"
//                   title="HighlightOff"
//                   fill="#b2b2b2"
//                 >
//                   <path d="M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"></path>
//                 </svg>
//               </div>
//             )}
//           </div>
//         </span>
//       )}
//     </Picker>
//   );
// };

// export default DateRangePicker;


import { useState, useRef } from 'react';
import { DateRangePicker } from 'rsuite';
import { FaCalendar, FaClock } from 'react-icons/fa';
import 'rsuite/dist/rsuite.min.css'; // Import RSuite CSS

const DatePicker = () => {
    const [showDatePicker, setShowDatePicker] = useState(false);

    const [dateRange, setDateRange] = useState([new Date(), new Date()]); // Initial date range
    const [resetDate,setResetDate] = useState(true);
    const datePickerContainerRef = useRef(null);

    const reset = () => {
        setDateRange([new Date(), new Date()]);
        setResetDate(true);
      }

      const formatDateTime = (date) => {
        if (!date) return '';
        const year = date.getFullYear().toString().slice(-2); // Extract last 2 digits of the year
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two-digit month
        const day = String(date.getDate()).padStart(2, '0'); // Ensure two-digit day
        const hours = String(date.getHours()).padStart(2, '0'); // Ensure two-digit hours
        const minutes = String(date.getMinutes()).padStart(2, '0'); // Ensure two-digit minutes
        const seconds = String(date.getSeconds()).padStart(2, '0'); // Ensure two-digit seconds
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    return (
        <div>
            <style>
                {`
                /* Hide the default DateRangePicker input */
                 .rs-picker-input-group {
                    visibility: hidden !important;
                }
                `}
            </style>

            <div className="picker-container w-full "> {/* Parent container */}

                {/* Custom Input for Date Picker */}
                <div className='relative'>
                    <div ref={datePickerContainerRef} className="relative w-[280px]"> {/* Adding margin-top */}
                        <span>
                            <div className='w-[350px] h-[40px] bg-[white] text-[#b2b2b2] items-center border border-[#dcdfe6] rounded flex group z-0'>
                                <div onClick={() => setShowDatePicker(true)} className='w-[290px] h-full flex'>
                                    <div className='flex flex-col justify-center'>
                                        <svg
                                        className="w-4 h-4 ml-3"
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        data-testid="CalendarMonthIcon"
                                        title="CalendarMonth"
                                        fill='#b2b2b2'
                                        >
                                        <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 16H5V10h14zM9 14H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2zm-8 4H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2z"></path>
                                        </svg>
                                    </div>
                                    <input
                                        placeholder="Start Date"
                                        className="w-[130px] h-full outline-none text-center text-[black]"
                                        value={
                                            !resetDate ? formatDateTime(dateRange[0]) : 'Start Date'
                                        }
                                    />
                                    <div className='flex flex-col justify-center'>
                                        <span>~</span>
                                    </div>
                                    <input
                                        placeholder="End Date"
                                        className="w-[130px] h-full outline-none text-center text-[black]"
                                        value={
                                            !resetDate ? formatDateTime(dateRange[1]) : 'End Date'
                                        }
                                    />
                                </div>
                                {dateRange.length > 1 && (
                                    <div onClick={reset} className='h-[40px] w-[40px] outline-none bg-[transparent] flex flex-col justify-center z-100 cursor-pointer'>
                                        <svg
                                            className="w-4 h-4 ml-5 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                                            focusable="false"
                                            viewBox="0 0 24 24"
                                            data-testid="HighlightOffIcon"
                                            title="HighlightOff"
                                            fill='#b2b2b2'
                                        >
                                            <path d="M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"></path>
                                        </svg>
                                    </div>
                                )}

                            </div>
                        </span>
                        {showDatePicker && (
                            <div className="absolute top-[10px] left-[0px]"> {/* Adjusting the date picker position */}
                                <DateRangePicker
                                    format="dd MMM yyyy hh:mm:ss aa"
                                    defaultValue={[new Date(), new Date()]}
                                    value={dateRange}
                                    showMeridiem
                                    caretAs={FaCalendar}
                                    open={true} // Keep it open when visible
                                    onChange={(newRange) => {
                                        setDateRange(newRange);
                                        setResetDate(false);
                                    }}
                                    onClose={() => setShowDatePicker(false)} // Close on focus loss
                                    container={datePickerContainerRef.current} // Attach picker to container
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DatePicker;

